import ProvidesContacts from "../../mixins/provides-contacts";
import ComposeMail from "../../mixins/compose-mail";
import TabState from "../../mixins/tab-state";
import LoadSavedReplies from "../../mixins/load-email-saved-replies";
import BackToTop from "vue-backtotop";
import { mapGetters } from "vuex";
import HasLeaseContactGroup from "../../mixins/has-lease-contact-group";
import ArchivingMixin from "../../mixins/archiving-mixin";

Vue.component("view-ticket", {
    mixins: [
        ArchivingMixin,
        ProvidesContacts,
        ComposeMail,
        LoadSavedReplies,
        HasLeaseContactGroup,
        TabState
    ],
    components: {BackToTop},
    props: [
        "ticket",
        "users",
        "contacts",
        "currentServiceProvider",
        "ticketSettings",
        "assetGroup"
    ],
    data () {
        return {
            isLoadingActivityList: false,
            editActivityForm: new AppForm({}),
            selectedContact: null,
            isLoadingIssues: true,
            serviceProviderContacts: [],
            mutableTicket: this.ticket,
            selectedServiceProvider: this.currentServiceProvider,
            showQuotesAndInvoicesPanel: false,
            showTransactionRequestsPanel: false,

            form: new AppForm({}),

            showingChannelModal: false,
            showCloseTicketModal: false,
            documentsListUrl: "",
        };
    },
    created () {
        this.selectedServiceProvider = this.mutableTicket.service_provider;

        let self = this;

        let url = new URL(window.location.href);
        let openQuotesAndInvoicesPanel = url.searchParams.get("open-quotes-invoices-panel");
        if (openQuotesAndInvoicesPanel) {
            setTimeout(function () {
                self.toggleQuotesAndInvoicesPanel();
            }, 3000);
        }

        Bus.$on("ticket-updated", function (ticket) {
            self.mutableTicket = ticket;

            if (self.mutableTicket.resolved_at && self.mutableTicket.status === "closed") {
                self.todoUpdated(null);
            }
            // For some reason when saving the ticket from the TicketMainDetailsForm, the assignedTo object is loaded instead of the assigned_to id
            if (typeof self.mutableTicket.assigned_to === "object" && self.mutableTicket.assigned_to !== null) {
                self.mutableTicket.assigned_to = self.mutableTicket.assigned_to.id;
            }
        });

        Bus.$on("ticket-asset-updated", function (response) {
            self.mutableTicket.asset = response.asset;
            self.mutableTicket.asset_id = response.asset.id;
            self.mutableTicket.asset_name = response.asset.name;

            if (self.mutableTicket.next_todo) {
                self.mutableTicket.next_todo.asset = response.asset;
                self.mutableTicket.next_todo.asset_id = response.asset.id;
                self.mutableTicket.next_todo.users.splice(0);
                if (response.todo_users && response.todo_users.length > 0) {
                    response.todo_users.forEach(user => self.mutableTicket.next_todo.users.push(user));
                }
                Bus.$emit("update-users-list");
            }

            self.setSelectedContactGroup(null);
        });

        Bus.$on("update-ticket-description", function () {
            if (self.mutableTicket.description_managed_by_system) {
                self.fetchTicketDescription();
            }
        });

        Bus.$on("issue-list-loaded", function () {
            self.isLoadingIssues = false;
        });

        Bus.$on("share-document", function (document) {
            self.shareDocument(document);
        });

        Bus.$on("share-document-with-selected-contact", function (document, contactId) {
            self.shareDocumentWithSelectedContact(document, contactId);
        });

        Bus.$on("showing-channel", function () {
            self.showingChannelModal = true;
        });

        Bus.$on("closing-channel", function () {
            self.showingChannelModal = false;
        });
    },
    mounted () {
        this.selectedLeaseContactGroup = this.ticket.lease_contact_group;

        if (this.selectedServiceProvider !== null) {
            this.fetchServiceProviderContacts();
        }

        this.emailCreateUrl = "/tickets/" + this.mutableTicket.id + "/emails/create";
        this.documentsListUrl = "/tickets/" + this.mutableTicket.id + "/documents";
    },
    computed: {
        ...mapGetters(["mutableEmailContext"]),
        contactsUrl () {
            return "/contacts/ticket/" + this.mutableTicket.id;
        },
        documentUploadUrl () {
            return "/tickets/" + this.mutableTicket.id + "/documents/upload";
        },
        showAssetNotes () {
            return this.hasAssetNotes || this.hasComplexNotes;
        },
        hasAssetNotes () {
            return this.mutableTicket.asset.notes !== null && this.mutableTicket.asset.notes.trim() !== "";
        },
        hasComplexNotes () {
            return this.assetGroup !== null && (this.assetGroup.notes !== null && this.assetGroup.notes.trim() !== "");
        },
        ticketResolveConfirmationText () {
            return this.mutableTicket.resolved_at
                ? "Are you sure to unresolve this ticket?"
                : "Are you sure to resolve this ticket?";
        },
        ticketResolveTooltipText () {
            return this.mutableTicket.resolved_at
                ? "Click to unresolve"
                : "Click to resolve";
        },
        ticketCreationStatus () {
            if (!this.mutableTicket.draft_ticket) {
                return "";
            }

            if (!this.mutableTicket.draft_ticket.completed_at && this.$dayjs().diff(this.mutableTicket.draft_ticket.created_at, "h") >= 1) {
                return "error";
            } else {
                return "creating";
            }
        },
    },
    methods: {
        /**
         * Emit event to have asset select component show
         * for changing the asset
         */
        changeAsset () {
            Bus.$emit("show-asset-select-form");
        },
        onlyNumber (event) {
            let keyCode = (event.keyCode ? event.keyCode : event.which);
            if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
                event.preventDefault();
            }
        },
        roundContractedValue () {
            this.detailsUpdateForm.contracted_value = Number(this.detailsUpdateForm.contracted_value).toFixed(2);
        },
        newTicketEmail () {
            this.emailContext.model = {
                type: "ticket",
                id: this.ticket.id
            };

            this.createEmail(null, null, function () {
                Bus.$emit("refresh-activity-list");
            });
        },
        reopenTicket () {
            App.patch("/tickets/" + this.mutableTicket.id + "/status/open", new AppForm({}))
            .then(response => {
                this.toggleTicketStatus(!!this.mutableTicket.resolved_at);
                Bus.$emit("refresh-activity-list");
                toastr.success("Ticket Reopened");
            }).catch(() => {
                toastr.error("Ticket could not be reopened!");
            });
        },
        afterArchiving (archiving) {
            if (archiving) {
                this.mutableTicket.archived_at = this.$dayjs();
            } else {
                this.mutableTicket.archived_at = null;
            }
        },
        toggleTicketStatus (resolved) {
            this.showCloseTicketModal = false;
            this.mutableTicket.status = this.mutableTicket.status === "open" ? "closed" : "open";
            if (this.mutableTicket.status === "closed") {
                this.mutableTicket.closed_at = this.$dayjs().format("D MMM YYYY");
            } else {
                this.mutableTicket.closed_at = null;
            }
            // Ticket can be open and resolved, but must stay resolved when reopened
            if (this.mutableTicket.resolved_at === null && resolved) {
                this.mutableTicket.resolved_at = this.$dayjs().format("D MMM YYYY");
            }

            if (this.mutableTicket.status === "closed" && this.mutableTicket.resolved_at) {
                this.todoUpdated(null);
            }
        },
        assignSelectedServiceProvider (serviceProvider) {
            this.$set(this.mutableTicket, "service_provider", serviceProvider);
            this.selectedServiceProvider = serviceProvider;
            this.mutableTicket.service_provider_id = serviceProvider.id;
            this.mutableTicket.service_provider_name = serviceProvider.name;
            Bus.$emit("refresh-activity-list");
            this.fetchServiceProviderContacts();
            Bus.$emit("new-contacts-available", "service provider");
        },
        unassignSelectedServiceProvider () {
            this.$set(this.mutableTicket, "service_provider", null);
            this.selectedServiceProvider = null;
            this.mutableTicket.service_provider_id = null;
            this.mutableTicket.service_provider_name = null;
            Bus.$emit("refresh-activity-list");
            Bus.$emit("contact-updated", "service provider");
        },
        fetchServiceProviderContacts () {
            axios.get("/contacts/serviceprovider/" + this.selectedServiceProvider.id)
            .then((response) => {
                this.serviceProviderContacts = response.data;
            })
            .catch((errors) => {
                toastr.error("Could not fetch contractors!");
            });
        },
        fetchTicketDescription () {
            axios.post("/tickets/" + this.mutableTicket.id + "/properties/description")
            .then(response => {
                this.mutableTicket.description = response.data.description;
            })
            .catch((errors) => {
                toastr.error("Could not fetch ticket properties!");
            });
        },
        shareDocumentWithSelectedContact (document, contactId) {
            this.emailContext.model = {
                type: "ticket",
                id: this.ticket.id
            };

            this.createEmail(contactId, document.id, function () {
                Bus.$emit("refresh-activity-list");
            });
        },
        emailContact (contact) {
            this.createEmail(contact.id, null, function () {
                Bus.$emit("refresh-activity-list");
            });
        },
        shareDocument (document) {
            this.emailContext.model = {
                type: "ticket",
                id: this.ticket.id
            };

            this.createEmail(null, document.id, function () {
                Bus.$emit("refresh-activity-list");
            });
        },
        toggleQuotesAndInvoicesPanel () {
            this.showQuotesAndInvoicesPanel = !this.showQuotesAndInvoicesPanel;
        },
        toggleTransactionRequestsPanel () {
            if (!this.mutableTicket.rams_asset_external_source) {
                toastr.error("Billing requests can only be made on tickets linked to RAMS assets.");
                return;
            }

            if (this.mutableTicket.lease_contact_group && this.mutableTicket.lease_contact_group.archived_at) {
                toastr.error("Billing requests can not be made on tickets linked to an archived lease");
                return;
            }

            this.showTransactionRequestsPanel = !this.showTransactionRequestsPanel;
        },
        archiveContactGroup () {
            this.$set(this.mutableTicket.lease_contact_group, "archived_at", this.$dayjs().format("YYYY-MM-DD HH:mm:ss"));
        },
        /**
         * Confirm ticket resolve status changed
         */
        onConfirm () {
            axios.patch(`${this.mutableTicket.id}/properties/resolve/change`)
            .then(response => {
                this.mutableTicket.resolved_at = response.data.resolved_at;
                toastr.success("Ticket has been successfully updated!");
                Bus.$emit("refresh-activity-list");
            })
            .catch((errors) => {
                toastr.error("Could not update ticket resolve status!");
            });
        },

        emitThreadCloseEvent () {
            Bus.$emit("thread-modal-closed");
        },

        viewTicketActivityLog () {
            window.open(`/activity-log?id=${this.mutableTicket.id}&type=Ticket`, "_blank");
        },

        updateResolveStatus (date = null) {
            this.mutableTicket.resolved_at = date;
            toastr.success("Ticket Resolve Date Updated");
        },

        showSMSCreateForm () {
            this.$refs.smsCreateForm.showSMSCreateForm();
        },

        todoUpdated (updatedTodo) {
            this.mutableTicket.next_todo = _.isEmpty(updatedTodo) ? null : updatedTodo;
        },

        documentTabClickedHandler () {
            // Change documents list URL when document tab is clicked, the watcher in DocumentsList will refresh the list
            let tempUrl = this.documentsListUrl;
            this.documentsListUrl = null;
            this.$nextTick(function () {
                this.documentsListUrl = tempUrl;
            });
        },

        detachMaintenanceRequests (ids) {
            this.mutableTicket.maintenance_requests = this.mutableTicket.maintenance_requests.filter(mr => !ids.includes(mr.id));
        },
    },
});
